<div id="webcamaccessnotificationdiv" #webcamAccessNotificationDiv
    *ngIf="visible"
    [class.is-error]="state === 'error'"
    [attr.role]="state === 'error' ? 'alert' : 'status'"
    aria-live="assertive"
    aria-atomic="true">

  <div class="media-access-panel">
    <ng-container *ngIf="state === 'waiting'">
      <p class="media-access-title">Camera and microphone required</p>
      <p class="media-access-message" *ngIf="isSeb; else nonSebWaiting">
        This exam is proctored. Camera and microphone access is enabled automatically — please wait<span class="waiting-dots" aria-hidden="true"><span>.</span><span>.</span><span>.</span></span>
      </p>
      <ng-template #nonSebWaiting>
        <p class="media-access-message">
          This exam is proctored and needs access to your <strong>camera</strong> and <strong>microphone</strong>.
        </p>
        <p class="media-access-hint">
          When your browser asks, choose <strong>Allow</strong>.
        </p>
      </ng-template>
      <div class="media-access-actions" *ngIf="showEnterButton">
        <button type="button"
          class="media-access-retry-btn"
          [class.loading]="enterLoading"
          [disabled]="enterLoading"
          (click)="onEnter()">
          Enter
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="state === 'error'">
      <p class="media-access-title">{{ errorTitle }}</p>
      <p class="media-access-message">{{ errorMessage }}</p>
      <ol class="media-access-steps" *ngIf="recoverySteps.length">
        <li *ngFor="let step of recoverySteps">{{ step }}</li>
      </ol>
      <div class="media-access-actions">
        <button type="button"
          class="media-access-retry-btn"
          [class.loading]="retrying"
          [disabled]="retrying"
          (click)="onRetry()">
          Try again
        </button>
      </div>
    </ng-container>
  </div>
</div>
